"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.termsAndConditionsCookieName = exports.swrConfig = exports.ariaLabelledby = exports.ariaDescribedby = exports.TIMEOUT_IN_MS = exports.DIALOG_MAX_WIDTH = exports.CTA_MIN_WIDTH = exports.CTA_MAX_WIDTH = void 0;
const TIMEOUT_IN_MS = exports.TIMEOUT_IN_MS = 10_000;
const swrConfig = exports.swrConfig = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  suspense: true
};
const termsAndConditionsCookieName = exports.termsAndConditionsCookieName = 'TermsAndConditions';
const DIALOG_MAX_WIDTH = exports.DIALOG_MAX_WIDTH = '900px';
const CTA_MIN_WIDTH = exports.CTA_MIN_WIDTH = '165px';
const CTA_MAX_WIDTH = exports.CTA_MAX_WIDTH = '330px';
const ariaLabelledby = exports.ariaLabelledby = '';
const ariaDescribedby = exports.ariaDescribedby = '';
